import type { ReactNode } from 'react';

import { BrandIcon } from '@ui/uikit/components/common/BrandIcon';

import type { WalletConnectType } from './model/walletsConfig';
import { WALLETS_CONFIG } from './model/walletsConfig';

type Props = {
  title: string;
  connectType: WalletConnectType;
  children: ReactNode;
};

export const WalletListItem = ({ title, connectType, children }: Props) => {
  const { Icon } = WALLETS_CONFIG[connectType] ?? {};

  return (
    <div className="flex justify-between items-center gap-2">
      <BrandIcon dataQa="profile-wallet" size="large" icon={Icon} label={title} />
      <div className="flex gap-2">{children}</div>
    </div>
  );
};
